import { QueryClient } from 'react-query';

export const ADMIN_NEWS = '/news';
export const NEWS_CATEGORY = '/news/categories';
export const NEWS_MULTI_CATEGORIES = '/news/multi-categories';
export const LIST_NEWS = '/news/query';

export const GET_NOTIFICATIONS = '/notifications/query';
export const CREATE_NOTIFICATION = '/notifications/push-multi-users-segments';

export const PORTFOLIOS = '/portfolios';
export const PORTFOLIOS_UPDATE = '/portfolios/update';

export const RECOMMENDS = '/recommends';
export const RECOMMENDS_HISTORY = '/recommends/history';
export const RECOMMENDS_VALIDATE = '/recommends/validate';
export const RECOMMENDS_CREATE = '/recommends/create';
export const RECOMMENDS_WATCH = '/recommends/watch';
export const RECOMMENDS_DELETE = '/recommends/delete';

export const ROOMS = '/rooms';

export const TICKERS = '/tickers';
export const GET_CURRENT_PRICE = '/tickers/get-current-price';

export const ENTRIES = '/entries';

/* User Controller */
export const USERS_LOGIN = '/users/login';
export const USERS_PROFILE = '/users/profile';
export const USERS_LOGIN_VALIDATE = '/users/login/validate';
export const USERS_LOGIN_VERIFY = '/users/login/verify';
export const USERS_SERVICE_INFO = '/users/service-info';
export const USERS_AUTHEN = '/users/auth';

/* Upload Controller */
export const MEDIA_UPLOAD = '/media/upload';

export const LIST_BANNERS = '/banners';

export const queryClient = new QueryClient();
